import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { me, listarPagos, descargarFacturasZip } from "../api";
import "./PagosView.css";

export default function PagosProfesionalView() {
  const [user, setUser] = useState(null);

  const [mes, setMes] = useState(() =>
    new Date().toISOString().slice(0, 7),
  );

  const [pagosMes, setPagosMes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [resumen, setResumen] = useState({
    totalMes: 0,
    totalTarjeta: 0,
    totalEfectivo: 0,
    totalProfesional: 0,
    profesionalTarjeta: 0,
    profesionalEfectivo: 0,
    parteCentro: 0,
    centroTarjeta: 0,
    centroEfectivo: 0,
  });

  const [dlTarjeta, setDlTarjeta] = useState(true);
  const [dlEfectivo, setDlEfectivo] = useState(true);
  const [downloading, setDownloading] = useState(false);
  const [downloadError, setDownloadError] = useState("");
  const [downloadInfo, setDownloadInfo] = useState("");

  useEffect(() => {
    me().then((r) => {
      if (r.user) setUser(r.user);
    });
  }, []);

  const porcentajeProfesional = user?.porcentaje_profesional
    ? Number(user.porcentaje_profesional)
    : 0;
  const porcentajeCentro = 100 - porcentajeProfesional;

  const calcularResumen = (items, porcentajeProf) => {
    let totalMes = 0;
    let totalTarjeta = 0;
    let totalEfectivo = 0;

    items.forEach((p) => {
      const amt = Number(p.amount) || 0;
      const method = String(p.payment_method || "").toLowerCase().trim();

      totalMes += amt;

      if (method === "efectivo") {
        totalEfectivo += amt;
      } else if (method === "tarjeta") {
        totalTarjeta += amt;
      }
    });

    const profesionalTarjeta = totalTarjeta * (porcentajeProf / 100);
    const profesionalEfectivo = totalEfectivo * (porcentajeProf / 100);
    const totalProfesional = profesionalTarjeta + profesionalEfectivo;

    const centroTarjeta = totalTarjeta - profesionalTarjeta;
    const centroEfectivo = totalEfectivo - profesionalEfectivo;
    const parteCentro = centroTarjeta + centroEfectivo;

    return {
      totalMes,
      totalTarjeta,
      totalEfectivo,
      totalProfesional,
      profesionalTarjeta,
      profesionalEfectivo,
      parteCentro,
      centroTarjeta,
      centroEfectivo,
    };
  };

  const loadPagosMes = async (mesStr) => {
    if (!mesStr) return;
    try {
      setLoading(true);

      const { items } = await listarPagos({
        page: 1,
        page_size: 5000,
        month: mesStr,
        all_month: 1,
      });

      const lista = items || [];

      setPagosMes(lista);
      setResumen(calcularResumen(lista, porcentajeProfesional || 0));
      setError("");
    } catch (e) {
      console.error(e);
      setError(e.message || "Error al cargar pagos");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!user) return;
    if (user.role === "admin") return;
    loadPagosMes(mes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, mes]);

  const pagosParaDescarga = useMemo(() => {
    return (pagosMes || []).filter((p) => {
      const method = String(p.payment_method || "").toLowerCase();
      if (method === "tarjeta" && !dlTarjeta) return false;
      if (method === "efectivo" && !dlEfectivo) return false;
      return true;
    });
  }, [pagosMes, dlTarjeta, dlEfectivo]);

  if (!user) return <div style={{ padding: "1rem" }}>Cargando usuario...</div>;
  if (user.role === "admin") {
    return <div style={{ padding: "1rem" }}>Acceso restringido.</div>;
  }

  const onDescargarZip = async () => {
    try {
      setDownloading(true);
      setDownloadError("");
      setDownloadInfo("");

      if (!mes) throw new Error("No hay mes seleccionado");

      const ids = (pagosParaDescarga || [])
        .map((p) => Number(p.id))
        .filter((x) => Number.isFinite(x) && x > 0);

      if (!ids.length) throw new Error("No hay pagos para descargar");

      await descargarFacturasZip({ month: mes, paymentIds: ids });

      setDownloadInfo(`ZIP generado con ${ids.length} pagos.`);
    } catch (e) {
      setDownloadError(e?.message || "Error generando ZIP");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="pagos-container">
      <h2>Pagos profesionales</h2>

      <p className="pagos-user-info">
        Usuario: <strong>{user.email}</strong>{" "}
        {user.nombre && <>({user.nombre})</>} · Rol:{" "}
        <strong>{user.role}</strong>{" "}
        {user.porcentaje_profesional != null && (
          <>
            · Tú: <strong>{porcentajeProfesional}%</strong> · Centro:{" "}
            <strong>{porcentajeCentro}%</strong>
          </>
        )}
      </p>

      <div style={{ marginBottom: "1rem" }}>
        <label>
          Mes:{" "}
          <input
            type="month"
            value={mes}
            onChange={(e) => setMes(e.target.value)}
          />
        </label>
      </div>

      <div
        className="cierre-panel"
        style={{
          marginBottom: "1rem",
          padding: 12,
          border: "1px solid #ddd",
          borderRadius: 10,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 12,
            flexWrap: "wrap",
          }}
        >
          <div>
            <strong>Descargar facturas del mes ({mes})</strong>
            <div style={{ fontSize: 12, opacity: 0.8 }}>
              Solo tus pagos · IVA yoga se calcula en backend
            </div>
          </div>

          <button
            type="button"
            className="btn"
            onClick={onDescargarZip}
            disabled={downloading || loading || pagosParaDescarga.length === 0}
          >
            {downloading ? "Generando ZIP..." : "Descargar ZIP"}
          </button>
        </div>

        <div style={{ marginTop: 10, display: "flex", gap: 16 }}>
          <label className="chk-especialidad">
            <input
              type="checkbox"
              checked={dlTarjeta}
              onChange={(e) => setDlTarjeta(e.target.checked)}
            />
            💳 Tarjeta
          </label>

          <label className="chk-especialidad">
            <input
              type="checkbox"
              checked={dlEfectivo}
              onChange={(e) => setDlEfectivo(e.target.checked)}
            />
            💵 Efectivo
          </label>
        </div>

        <div style={{ marginTop: 8, fontSize: 12, opacity: 0.8 }}>
          Pagos seleccionados: <strong>{pagosParaDescarga.length}</strong>
        </div>

        {downloadInfo && (
          <div style={{ marginTop: 8, fontSize: 12 }}>{downloadInfo}</div>
        )}
        {downloadError && (
          <div
            style={{
              marginTop: 8,
              color: "red",
              whiteSpace: "pre-wrap",
            }}
          >
            {downloadError}
          </div>
        )}
      </div>

      <div className="pagos-resumen">
        <div className="resumen-card">
          <span className="resumen-label">Total facturado (mes)</span>
          <span className="resumen-value">
            {resumen.totalMes.toFixed(2)} €
          </span>
        </div>

        <div className="resumen-card">
          <span className="resumen-label">Total tarjeta</span>
          <span className="resumen-value">
            {resumen.totalTarjeta.toFixed(2)} €
          </span>
        </div>

        <div className="resumen-card">
          <span className="resumen-label">Total efectivo</span>
          <span className="resumen-value">
            {resumen.totalEfectivo.toFixed(2)} €
          </span>
        </div>

        <div className="resumen-card">
          <span className="resumen-label">
            Tu parte tarjeta ({porcentajeProfesional}%)
          </span>
          <span className="resumen-value">
            {resumen.profesionalTarjeta.toFixed(2)} €
          </span>
        </div>

        <div className="resumen-card">
          <span className="resumen-label">
            Tu parte efectivo ({porcentajeProfesional}%)
          </span>
          <span className="resumen-value">
            {resumen.profesionalEfectivo.toFixed(2)} €
          </span>
        </div>

        <div className="resumen-card">
          <span className="resumen-label">
            Tu parte total ({porcentajeProfesional}%)
          </span>
          <span className="resumen-value">
            {resumen.totalProfesional.toFixed(2)} €
          </span>
        </div>

        <div className="resumen-card">
          <span className="resumen-label">
            Centro tarjeta ({porcentajeCentro}%)
          </span>
          <span className="resumen-value">
            {resumen.centroTarjeta.toFixed(2)} €
          </span>
        </div>

        <div className="resumen-card">
          <span className="resumen-label">
            Centro efectivo ({porcentajeCentro}%)
          </span>
          <span className="resumen-value">
            {resumen.centroEfectivo.toFixed(2)} €
          </span>
        </div>

        <div className="resumen-card">
          <span className="resumen-label">
            Parte centro total ({porcentajeCentro}%)
          </span>
          <span className="resumen-value">
            {resumen.parteCentro.toFixed(2)} €
          </span>
        </div>
      </div>

      {loading && <p>Cargando pagos...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {!loading && !error && (
        <>
          <p className="pagos-total-resultados">
            Total resultados: <strong>{pagosMes.length}</strong>
          </p>

          {pagosMes.length === 0 ? (
            <p>No hay pagos registrados este mes.</p>
          ) : (
            <table className="pv-table pagos">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Paciente</th>
                  <th>Especialidad</th>
                  <th>Servicio</th>
                  <th>Importe (€)</th>
                  <th>Método</th>
                  <th>Estado</th>
                  <th>Enviado</th>
                  <th>Factura</th>
                </tr>
              </thead>
              <tbody>
                {pagosMes.map((p) => (
                  <tr key={p.id}>
                    <td>{new Date(p.date).toLocaleDateString("es-ES")}</td>
                    <td
                      className="paciente-cell"
                      title={`${p.paciente} ${p.apellidos || ""}`}
                    >
                      <strong>{p.paciente}</strong> {p.apellidos}
                    </td>
                    <td>{p.specialty_name || p.specialty_code || "—"}</td>
                    <td className="service-cell">{p.service_name || "-"}</td>
                    <td className="importe-cell">
                      {Number(p.amount).toFixed(2)} €
                    </td>
                    <td>
                      {p.payment_method === "efectivo"
                        ? "💵 Efectivo"
                        : "💳 Tarjeta"}
                    </td>
                    <td>
                      <span
                        className={`status-pill ${
                          p.status === "pagado" ? "status-pagado" : ""
                        }`}
                      >
                        {p.status === "pagado" ? "Pagado" : p.status || "—"}
                      </span>
                    </td>
                    <td>
                      <span
                        className={`badge-enviado ${
                          p.enviado ? "enviado" : "no-enviado"
                        }`}
                      >
                        {p.enviado ? "Enviado" : "Sin enviar"}
                      </span>
                    </td>
                    <td className="factura-cell">
                      <Link to={`/factura/${p.id}`} title="Ver factura">
                        <i className="fa-solid fa-file-invoice" />
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </>
      )}
    </div>
  );
}